import React, { Component } from 'react'
import * as FlexWebChat from '@twilio/flex-webchat-ui'

export class HideChat extends Component {
  render () {
    if (this.props.isEntryPointExpanded) {
      return null
    }
    return (
      <div className="hide-chat" onClick={this._hideChat}>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
        </svg>
      </div>
    )
  }

  _hideChat = async () => {
    document.querySelector('#twilio-chat-component').style.display = 'none'
    try{
      const state = this.props.manager.store.getState()
      const {chat, session} = state.flex
      const { channelSid, tokenPayload } = session
      const { attributes } = chat.channels[channelSid].source
  
      const body = {
        channelSid,
        attributes: JSON.stringify(attributes),
         Token: tokenPayload?.token
      }
  
      const options = {
        method: "POST",
        body: new URLSearchParams(body),
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      }
      await fetch('https://service-webchat-customerside-2078.twil.io/end-task-by-customer', options)
    }catch(err){
      console.error(err)//Catch vazio apenas para não quebrar a tela do cliente
    }
    FlexWebChat.Actions.invokeAction('RestartEngagement')
  }
}
